import ContractorRegistrationModifyPage from "../../shared/contractor-registration/ContractorRegistrationModifyPage";
import { CONTRACTOR_REGISTRATION_CONFIG } from "../../shared/contractor-registration/contractorRegistrationConfig";

export default function SolarentOperatorContractorRegistrationModifyPage() {
  return (
    <ContractorRegistrationModifyPage
      {...CONTRACTOR_REGISTRATION_CONFIG.solarentOperator}
    />
  );
}
